import {createSelector} from 'reselect';
import {getSelectedDeliveryCountry, getSettings} from './selectors';

export default createSelector(
  [getSettings, getSelectedDeliveryCountry],
  (settings, country) => (
    settings.address_lookup_exp_countries?.includes(country) && settings.disable_autocomplete
      ? 'new-password' : undefined),
);
